export const NotificationIcon = () => (
  <svg width="20" height="20" viewBox="-2 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4167 17.7083C10.6354 17.7083 10.8333 17.9062 10.8333 18.125C10.8333 18.1792 10.8255 18.2333 10.8125 18.2812C10.4167 19.375 9.375 20.1667 8.125 20.1667C6.875 20.1667 5.83333 19.375 5.4375 18.2812C5.42448 18.2333 5.41667 18.1792 5.41667 18.125C5.41667 17.9062 5.61458 17.7083 5.83333 17.7083H10.4167ZM8.125 2.08333C9.27917 2.08333 10.2083 3.01249 10.2083 4.16666V4.26041C12.1354 4.95832 13.5417 6.61457 13.7708 8.60415L14.1667 12.3958C14.2396 13.0833 14.5208 13.7396 14.9792 14.2812C16.0312 15.5833 15.0729 17.3958 13.3229 17.3958H2.92708C1.17708 17.3958 0.21875 15.5833 1.27083 14.2812C1.72917 13.7396 2.01042 13.0833 2.08333 12.3958L2.47917 8.60415C2.70833 6.61457 4.11458 4.95832 6.04167 4.26041V4.16666C6.04167 3.01249 6.97083 2.08333 8.125 2.08333Z"
      stroke="#302F2D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
